import { __read, __spreadArray } from "tslib";
import { getEffectiveMaskLevel, maskFn, maskAttributeFn } from './policy';
export var getBlockSelectors = function (config) {
    var configured = config === null || config === void 0 ? void 0 : config.blockSelector;
    var selectors = typeof configured === 'string' ? (configured ? [configured] : []) : configured !== null && configured !== void 0 ? configured : [];
    return __spreadArray(__spreadArray([], __read(selectors), false), ['[data-amp-block]'], false).join(',');
};
export var getMaskTextSelectors = function (config, url) {
    var _a, _b;
    // rrweb selects which text reaches the callback at recorder startup. Include all
    // text if any route can require conservative masking; callbacks resolve the URL dynamically.
    if (config &&
        (getEffectiveMaskLevel(url, config) === 'conservative' ||
            config.defaultMaskLevel === 'conservative' ||
            ((_a = config.urlMaskLevels) === null || _a === void 0 ? void 0 : _a.some(function (rule) { return rule.maskLevel === 'conservative'; }))))
        return '*';
    return __spreadArray(__spreadArray([], __read(((_b = config === null || config === void 0 ? void 0 : config.maskSelector) !== null && _b !== void 0 ? _b : [])), false), ['[data-amp-mask]'], false).join(',');
};
/** Lifecycle and URL observation belong to the caller. Replace the recorder when policy changes. */
export var createPrivacyRecorderOptions = function (config, getCurrentUrl) {
    if (getCurrentUrl === void 0) { getCurrentUrl = function () { return ''; }; }
    var blockSelector = getBlockSelectors(config);
    return {
        maskAllInputs: true,
        maskTextClass: 'amp-mask',
        blockClass: 'amp-block',
        blockSelector: blockSelector,
        maskTextSelector: getMaskTextSelectors(config, getCurrentUrl()),
        maskInputFn: maskFn('input', config, getCurrentUrl),
        maskTextFn: maskFn('text', config, getCurrentUrl),
        maskAttributeFn: maskAttributeFn(config, getCurrentUrl),
    };
};
//# sourceMappingURL=recorder-options.js.map